import React from 'react'
import { Popover } from 'react-tiny-popover'
import { toUpper } from 'lodash'

import labels from '../../configuration/labels'

import '../../styles/scss/components/elements/filter-popover-wrapper.scss'

const FilterPopoverWrapper = ({
  alignment,
  children,
  hasClearBtn,
  isPopoverOpen,
  onClosePopover,
  onClear,
  onSubmit,
  popoverClassName,
  PopoverTab,
}) => {
  const PopoverContent = () => (
    <div className="filter-popover__content">
      {children}
      <div className="filter-popover__content-footer">
        {hasClearBtn ? (
          <>
            <button className="btn btn-clear" onClick={onClear}>
              {toUpper(labels.filteredEventsBtnClear)}
            </button>
            <button className="btn btn-submit" onClick={onSubmit}>
              {toUpper(labels.filteredEventsBtnApplyFilter)}
            </button>
          </>
        ) : (
          <button className="btn btn-submit full-width" onClick={onSubmit}>
            {toUpper(labels.filteredEventsBtnApplyFilter)}
          </button>
        )}
      </div>
    </div>
  )

  return (
    <Popover
      containerClassName={`decoupled-events-popover filter-popover-wrapper ${popoverClassName}`}
      containerParent={document.getElementById('decoupled-events')}
      isOpen={isPopoverOpen}
      onClickOutside={onClosePopover}
      align={alignment}
      positions={['bottom', 'left']}
      content={PopoverContent}
    >
      {PopoverTab}
    </Popover>
  )
}

export default FilterPopoverWrapper
